// /assets/js/gsap-boot.js
(function () {
  if (!window.gsap) {
    console.error("[GSAP Boot] gsap not found on window. Check script order.");
    return;
  }
  if (window.__gsapBoot) return;

  if (window.ScrollTrigger) gsap.registerPlugin(ScrollTrigger);
  if (window.ScrollSmoother) gsap.registerPlugin(ScrollSmoother);

  if (window.ScrollTrigger) {
    ScrollTrigger.defaults({
      invalidateOnRefresh: true,
      // markers: true,
    });
    window.addEventListener("load", () => ScrollTrigger.refresh());
  }

  function applyParallaxAttrs(isMobile) {
    gsap.utils.toArray("[data-speed]").forEach((el) => {
      // store original desktop values once
      if (!el.hasAttribute("data-speed-desktop")) {
        el.setAttribute(
          "data-speed-desktop",
          el.getAttribute("data-speed") || "1"
        );
      }
      if (el.hasAttribute("data-lag") && !el.hasAttribute("data-lag-desktop")) {
        el.setAttribute("data-lag-desktop", el.getAttribute("data-lag") || "0");
      }

      const desktopSpeed = parseFloat(
        el.getAttribute("data-speed-desktop") || "1"
      );
      const mobileSpeedAttr = el.getAttribute("data-speed-mobile");
      const mobileSpeed = mobileSpeedAttr ? parseFloat(mobileSpeedAttr) : NaN;

      const speedToUse =
        isMobile && !Number.isNaN(mobileSpeed) ? mobileSpeed : desktopSpeed;

      el.setAttribute("data-speed", String(speedToUse));

      // lag swap (optional)
      if (el.hasAttribute("data-lag-desktop")) {
        const desktopLag = parseFloat(
          el.getAttribute("data-lag-desktop") || "0"
        );
        const mobileLagAttr = el.getAttribute("data-lag-mobile");
        const mobileLag = mobileLagAttr ? parseFloat(mobileLagAttr) : NaN;

        const lagToUse =
          isMobile && !Number.isNaN(mobileLag) ? mobileLag : desktopLag;

        el.setAttribute("data-lag", String(lagToUse));
      }
    });
  }

  function initScrollSmoother() {
    if (typeof ScrollSmoother === "undefined") return;

    const wrapper = document.querySelector("#smooth-wrapper");
    const content = document.querySelector("#smooth-content");
    if (!wrapper || !content) return;

    const mm = gsap.matchMedia();

    mm.add(
      {
        isMobile: "(max-width: 768px)",
        isDesktop: "(min-width: 769px)",
      },
      (context) => {
        const { isMobile } = context.conditions;

        // update attributes for this breakpoint
        applyParallaxAttrs(isMobile);

        // recreate smoother for this breakpoint (safe + predictable)
        if (window.__smoother) {
          window.__smoother.kill();
          window.__smoother = null;
        }

        window.__smoother = ScrollSmoother.create({
          wrapper: "#smooth-wrapper",
          content: "#smooth-content",
          smooth: isMobile ? 0.7 : 1.2,
          smoothTouch: isMobile ? 0.08 : 0.1,
          effects: false, // we will apply effects explicitly below
        });

        // apply effects once, based on final data-speed/data-lag attributes
        window.__smoother.effects("[data-speed],[data-lag]");
        ScrollTrigger.refresh();

        return () => {
          if (window.__smoother) {
            window.__smoother.kill();
            window.__smoother = null;
          }
        };
      }
    );
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", initScrollSmoother);
  } else {
    initScrollSmoother();
  }

  window.__gsapBoot = true;
})();
